import React from 'react';
import '../../../styles/irctcAboutInfo.css';
import { IRCTC_LOGIN_ABOUT } from '../../../utils/RailsSEOConstants';
import { navigateTo } from '../../../utils/commonUtils';
import PropTypes from 'prop-types';

const AboutInfo = ({ customClass }) => {
  return (
    <div className={`${customClass} aboutContainer`}>
      <ul>
        {IRCTC_LOGIN_ABOUT.map((item) => {
          return (
            <li key={item.title} onClick={() => navigateTo(item.navigationUrl)}>
              {item.title}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

AboutInfo.propTypes = {
  customClass: PropTypes.string
};

export default AboutInfo;
